//THIS COMPONENT IS UNUSED, SCHEDULED FOR DELETION

import React, { Component, Fragment } from 'react';
import {
  Button,
  Col,
  Form,
  List,
  Modal,
  Row,
  Select,
  Spin,
  Tabs,
  Tooltip,
  Table,
  Popover,
} from 'antd';
import styles from './custom-feed.module.sass';
import { STATUS } from '../../../../redux/constants';
import SAFeedContainer from '../../../../containers/SAFeedContainer';
import history from '../../../../redux/history';
import Icon, {
  PlusCircleFilled,
  ArrowLeftOutlined,
  InfoCircleFilled,
} from '@ant-design/icons';
import FeedRow from './FeedRow';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';

const initialState = {
  selectedFeed: null,
  showCreateModal: false,
  scores: {},
  activeKey: '1',
  showDirectlyAddNew: false,
};

class Feeds extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = initialState;
  }

  componentDidMount() {
    document.title = 'Feeds - Silent Push';
    this.props.loadFeeds();
    this.props.loadGlobalFeeds();
    this.props.loadUser();
    this.props.loadFilters();
  }

  handleTabChange = (selectedkey) => {
    this.setState({ ...initialState, activeKey: selectedkey });
  };

  handleToggleModalClick = () => {
    const showCreateModal = !this.state.showCreateModal;
    if (showCreateModal) {
      this.props.loadAvailableFeeds();
    }
    this.setState({ showCreateModal, selectedFeed: null });
  };

  handleAddClick = async () => {
    const ref = this.formRef.current;
    try {
      await ref.validateFields();
      const formData = ref.getFieldsValue();

      this.props.createFeed({
        global_feed: formData.feed,
      });
      this.setState({ showCreateModal: false, selectedFeed: null });
      ref.resetFields();
    } catch (e) {}
  };

  handleSimpleAddClick = () => {
    this.props.loadAvailableFeeds();
    this.props.simpleAddFeed();
  };

  handleSelectedFeedChange = (selectedFeedUUID) => {
    const { availableFeeds } = this.props;
    const selectedFeed = availableFeeds.find(
      (feed) => feed.uuid === selectedFeedUUID,
    );
    this.setState({ selectedFeed });
  };

  renderCreateModal = () => {
    const { showCreateModal, selectedFeed } = this.state;
    const { availableFeeds, globalFeedsStatus } = this.props;
    return (
      <Modal
        title="Ingest Feeds from Available Feeds"
        visible={showCreateModal}
        onCancel={this.handleToggleModalClick}
        onOk={this.handleAddClick}
        okText="Ingest"
      >
        <Form ref={this.formRef}>
          <Form.Item
            label="Feed"
            name="feed"
            rules={[{ required: true, message: 'Feed is required' }]}
          >
            <Select
              showSearch
              allowClear
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >
                -1
              }
              options={availableFeeds.map((item) => ({
                value: item.uuid,
                label: item.name,
              }))}
              loading={globalFeedsStatus === STATUS.LOADING}
              onChange={this.handleSelectedFeedChange}
              getPopupContainer={(trigger) => trigger.parentNode}
            />
          </Form.Item>
        </Form>
        {selectedFeed && (
          <Row>
            <Col span={3}>Vendor: </Col>
            <Col>{selectedFeed.vendor}</Col>
          </Row>
        )}
      </Modal>
    );
  };

  handleBackClick = () => {
    history.push('/');
  };

  renderList = () => {
    const { status, feeds } = this.props;

    return (
      <Fragment>
        <h1>Feed Sources</h1>

        <div className={styles['add-btn-container']}>
          <Button
            icon={<Icon component={PlusCircleFilled} />}
            className={styles['add-btn']}
            onClick={this.handleToggleModalClick}
          >
            Ingest Feeds from Available Feeds
          </Button>
        </div>
        <div className={styles['add-btn-container']}>
          <Button
            icon={<Icon component={PlusCircleFilled} />}
            className={styles['add-btn']}
            //onClick={this.handleToggleModalClick}
            onClick={() => {
              this.setState({
                showDirectlyAddNew: true,
                activeKey: '3',
              });
            }}
          >
            Create New Feed
          </Button>
        </div>

        <List
          loading={status === STATUS.LOADING}
          header={
            <Row className={styles.row_cols}>
              <Col span={1}></Col>
              <Col span={3}>Source Name</Col>
              <Col span={2}>Type</Col>
              <Tooltip title="Include feed in threat ranking">
                <Col span={1}>On/Off</Col>
              </Tooltip>
              <Tooltip title="Set trust level for feed">
                <Col span={3}>Label</Col>
              </Tooltip>
              <Tooltip title="List of all tags assigned to the source">
                <Col span={3}>Tag</Col>
              </Tooltip>
              <Col span={2}>Importance</Col>
              <Tooltip title="User specified score assigned to this feed, that overrides Silent Push system's calculated feed score">
                <Col span={2}>Source Score</Col>
              </Tooltip>
              {/* <Col span={1}>CPM</Col> */}
              <Col span={1}>Duration (days)</Col>
              <Tooltip title="The percentage of this feed's observables that are provided by other feeds/collections">
                <Col span={2}>Overlap</Col>
              </Tooltip>
              <Tooltip title="The percentage of observables that this feed/collection reported first">
                <Col span={1}>Originator</Col>
              </Tooltip>
              <Col span={2}></Col>
            </Row>
          }
          locale={{
            emptyText: 'No Feeds',
          }}
          bordered
          dataSource={feeds}
          renderItem={(feed) => (
            <List.Item style={{ padding: 0 }}>
              <FeedRow
                resetTagSearch={this.props.resetTagSearch}
                searchStatus={this.props.searchStatus}
                searchForTags={this.props.searchForTags}
                foundTags={this.props.foundTags}
                deleteEmptyFeed={this.props.deleteEmptyFeed}
                key={feed.uuid}
                feed={feed}
                createFeed={this.props.createFeed}
                loadFeeds={this.props.loadFeeds}
                loadAvailableFeeds={this.props.loadAvailableFeeds}
                updateFeed={this.props.updateFeed}
                deleteFeed={this.props.deleteFeed}
                availableFeeds={this.props.availableFeeds}
              />
            </List.Item>
          )}
        />
        {/*<div className={styles['add-btn-container']}>
          <PlusCircleFilled
            style={{ fontSize: '30px' }}
            onClick={this.handleSimpleAddClick}
          />
          </div>*/}
      </Fragment>
    );
  };

  columns = [
    {
      title: <ColumnTitle columnName="Feed Name" />,
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      //...getColumnSearchProps('name'),
    },
    {
      title: <ColumnTitle columnName="Frequency (hours)" />,
      dataIndex: 'frequency',
      key: 'frequency',
      sorter: (a, b) => a.frequency - b.frequency,
      //...getColumnSearchProps('name'),
    },
    {
      title: <ColumnTitle columnName="Accuracy" />,
      dataIndex: 'accuracy_score',
      key: 'accuracy_score',
      sorter: (a, b) => a.accuracy_score - b.accuracy_score,
      //...getColumnSearchProps('name'),
    },
    {
      title: <ColumnTitle columnName="False Positive Ratio" />,
      dataIndex: 'false_positive_ratio',
      key: 'false_positive_ratio',
      sorter: (a, b) => a.false_positive_ratio - b.false_positive_ratio,
      //...getColumnSearchProps('name'),
    },
    // {
    //   title: 'Add to threat ranking',
    //   dataIndex: 'address',
    //   key: 'address',
    // },
    {
      title: <ColumnTitle columnName="Overlap" />,
      dataIndex: 'overlap_score',
      key: 'overlap_score',
      sorter: (a, b) => a.overlap_score - b.overlap_score,
      render: (text, record) => (
        <span>
          <Popover
            content={
              <>
                <div>
                  Percentage of items overlapping with other Feeds/Collections
                </div>
                <div>Total IOC: {record?.overlap_detail?.total_ioc}</div>
                <div>
                  Total Overlap: {record?.overlap_detail?.total_overlap}
                </div>
              </>
            }
          >
            {text} % <InfoCircleFilled />
          </Popover>
        </span>
      ),
    },
    {
      title: <ColumnTitle columnName="Originator" />,
      dataIndex: 'originator_score',
      key: 'originator_score',
      sorter: (a, b) => a.originator_score - b.originator_score,
      render: (text, record) => (
        <span>
          <Popover
            content={
              <>
                <div>
                  Percentage of firstly reported items since the Feed/Collection
                  was added
                </div>
                <div>
                  First Time IOC Reported:{' '}
                  {record?.originator_detail?.first_time_ioc_reported}
                </div>
                <div>
                  IOC Reported: {record?.originator_detail?.ioc_reported}
                </div>
              </>
            }
          >
            {text} % <InfoCircleFilled />
          </Popover>
        </span>
      ),
    },
    // {
    //   title: '',
    //   key: 'actions',
    //   render: (record) => (
    //     <div className={styles.action_buttons}>
    //       {/* <ShareIcon /> */}

    //       <Dropdown
    //         trigger={['click']}
    //         overlay={
    //           <DropdownMenu
    //             record={record}
    //             //lookupObject={lookupObject}
    //             //queryType={queryType}
    //             //objectType={type}
    //           />
    //         }
    //       >
    //         <div>
    //           {' '}
    //           <ThreeDotsIcon />{' '}
    //         </div>
    //       </Dropdown>
    //     </div>
    //   ),
    // },
  ];

  renderBenchmarkTable = () => {
    const { feeds } = this.props;
    return (
      <Fragment>
        <h1>Feed Performance</h1>

        {/* <div className={styles['add-btn-container']}>
          <Button
            icon={<Icon component={PlusCircleFilled} />}
            className={styles['add-btn']}
            onClick={this.handleToggleModalClick}
          >
            Add New
          </Button>
        </div> */}
        <div className={styles.benchmark_table}>
          <Table columns={this.columns} dataSource={feeds} pagination={false} />
        </div>
      </Fragment>
    );
  };

  render() {
    const { status } = this.state;
    const isLoading = status === STATUS.LOADING;
    return (
      <div className={styles.container}>
        {this.renderCreateModal()}
        {isLoading && <Spin style={{ margin: 40 }} />}
        {!isLoading && (
          <>
            {/*<div*/}
            {/*  className="threatRankingBackButton"*/}
            {/*  onClick={this.handleBackClick}*/}
            {/*>*/}
            {/*  <span className={styles.back_button}>*/}
            {/*    <ArrowLeftOutlined /> Back to Threat Ranking List*/}
            {/*  </span>*/}
            {/*</div>*/}
            <Tabs
              activeKey={this.state.activeKey}
              onChange={this.handleTabChange}
              type="card"
            >
              <Tabs.TabPane tab="Ingested Feeds" key="1">
                <div className={styles.feed_container}>{this.renderList()}</div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Feed Performance" key="2">
                <div className={styles.feed_container}>
                  {this.renderBenchmarkTable()}
                </div>
              </Tabs.TabPane>
              {
                <Tabs.TabPane tab="Available Feeds" key="3">
                  <div className={styles.feed_container}>
                    {this.state.activeKey === '3' ? (
                      <SAFeedContainer
                        showCreateForm={this.state.showDirectlyAddNew}
                      />
                    ) : (
                      ''
                    )}
                  </div>
                </Tabs.TabPane>
              }
            </Tabs>
          </>
        )}
      </div>
    );
  }
}

export default Feeds;
